import { trackLastTransactionsAmplitudeEvent } from '@/modules/transaction/helpers/track-amplitude-event';
import { FilterLabel } from './types';

export function trackFilterClick(filterLabel: FilterLabel, value: string) {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: value,
    page_screen_section: 'body',
    event_target: filterLabel
  });
}

export function trackWealthFilterClick() {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'filter_portfolio',
    page_screen_section: 'body'
  });
}

export function trackCleanFilterClick() {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'clean_filter',
    page_screen_section: 'body',
    event_target: 'Limpar filtro'
  });
}
